/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import { css } from '@emotion/react'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'
import { useDataProvider } from '../../hooks/dataProvider'
import { Button } from '../base-ui'

export default function ChangeLanguage() {
    const { data } = useDataProvider()
    const { locale, asPath, locales } = useRouter()
    const [expanded, setExpanded] = useState(false)
    function expand() {
        setExpanded(true)
    }

    function close() {
        setExpanded(false)
    }
    const otherLocales = locales.filter((loc) => loc !== locale)
    return (
        <div onBlur={close} style={{ position: 'relative' }}>
            <Button
                className="items-center justify-center"
                hoverColor="secondary"
                icon={<IoIosArrowDown />}
                onClick={() => {
                    if (expanded) close()
                    else expand()
                }}
                css={css`
                    box-shadow: none;
                `}
            >
                <Image
                    src={`/img/lang/${locale}.png`}
                    alt="language"
                    width={24}
                    height={12}
                />
            </Button>
            {expanded && (
                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        margin-top: 9px;
                        position: absolute;
                        background: #3a3d80;
                        box-shadow: 0 0 0 0.2rem rgb(149 163 255 / 50%);
                        border-radius: 0.25rem;
                        > a {
                            padding: 8px 8px 8px;
                            font-size: 0.8rem;
                            display: inline-flex;
                            cursor: pointer;
                            &:hover {
                                filter: contrast(120%);
                                background-color: #5a5fcd;
                            }
                        }
                    `}
                >
                    {otherLocales.map((loc) => {
                        let href = asPath
                        if (data?.changeLangOverrides?.[loc])
                            href = data.changeLangOverrides[loc]
                        // if (typeof pathMap === 'string') href = pathMap
                        // else if (pathMap !== null && pathMap[loc])
                        //     href = pathMap[loc]

                        return (
                            <Link key={loc} href={href} locale={loc}>
                                <a
                                    onMouseDown={(e) => {
                                        e.preventDefault()
                                    }}
                                >
                                    <Image
                                        src={`/img/lang/${loc}.png`}
                                        width={32}
                                        height={16}
                                    />
                                </a>
                            </Link>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
